import React from "react";
import { withTranslation } from "react-i18next";
import { ContractRequestPanelView } from "../../views";
import {
  ContractService,
  PlanService,
  LocalStorageService,
  SignerTypeService,
  QuestionnaireA3CloudService,
  UserService,
} from "../../../services/index";
import initialState from "../../../utils/initialState";
import { NIL as NIL_UUID } from "uuid";
// import { profileIconDefault } from "../../../assets/logos/icons";

class ContractRequestPanelAction extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      contractPlanExist: false,
      userType: "",
      title: props.t("contractRequest.title"),
      questionnairesName: [],
      companyFilterOptions: [],
      showErrorRequesting: false,
      messageError: ''
    };
  }

  token = {};
  url = process.env.REACT_APP_MIFIRMA_API;
  localStorageService = new LocalStorageService();

  questionnaires = new QuestionnaireA3CloudService(this.url);
  contractService = new ContractService(this.url);
  planService = new PlanService(this.url);
  signerTypeService = new SignerTypeService(this.url);
  userService = new UserService(this.url);

  async componentDidMount() {
    this.setState({ loading: true });
    this.token = this.localStorageService.getLocalStorageItem("token").idToken;
    let userContractPlan = initialState["planService.getUserContractAndPlan"];
    let user = this.localStorageService.getLocalStorageItem("user");

    try {
      let cuestionariosData = await this.questionnaires.getQuestionnairesNewContract(this.token);
      let companiesRoles = await this.userService.getUserRolesCompany(this.token, user.userMetaData.userMifirma.email);

      const validRoles = [
        +process.env.REACT_APP_COMPANY_ROLE_ID_ADMIN,
        +process.env.REACT_APP_COMPANY_ROLE_ID_N1,
        +process.env.REACT_APP_COMPANY_ROLE_ID_N2,
        +process.env.REACT_APP_COMPANY_ROLE_ID_N3,
      ];

      let questionnairesName;
      let companyFilterOptions = [
        {
          id: "",
          name: this.props.t("digitalContractDashboard.newContract.allBusiness")
        }, {
          id: NIL_UUID,
          name: this.props.t("questionnairesAssignCategories.no.assign")
        }
      ];
      let userRoles = user.userMetaData.userRoles;

      if (userRoles.findIndex(item => item.role.id == 5) != -1) {
        // Super admin sees all active questionnaires
        questionnairesName = cuestionariosData.questionnaires.filter((item) => item.active)
      } else {
        let assignedCompaniesIds = companiesRoles.data.companies.filter((item) => validRoles.includes(item.roleId)).map(item => item.companyId);
        // Show questionnaires that are:
        // - active and assigned to a company that the user is assigned to
        // - active and not assigned to any company
        questionnairesName = cuestionariosData.questionnaires.filter((item) => item.active && (assignedCompaniesIds.includes(item.companyId) || !item.company.id));
      }

      questionnairesName = questionnairesName.map((item) => {
        return {
          ...item, title: item.name, text: item.description, img: item.logo, url: {
            pathname: `/contract-generation/${item.id}`,
            params: { dataItem: item }
          }
        }
      })
      questionnairesName.map((item) => {
        item.img == "" ? item.img = "data:image/png;base64,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"
          : item.img = item.img
        return item
      })

      cuestionariosData.companies.map((company) => {
        company.name = company.companyName
        companyFilterOptions.push(company)
      })

      // companyFilterOptions.sort((a, b) => {
      //   return a.id > b.id ? 1 : -1;
      // });

      this.setState({
        questionnairesName,
        companyFilterOptions
      })

      // console.log(this.state)
      // this.setState({
      //     cardQueriesValidations: {
      //         title: cuestionariosData.name
      //     }
      // })

      userContractPlan = await this.planService.getUserContractAndPlan(
        this.token
      );
      initialState["planService.getUserContractAndPlan"] = userContractPlan;

      let contractCountTransactions =
        await this.contractService.getContractsTotalTransactions(this.token);

      if (
        userContractPlan.statusCode &&
        userContractPlan.statusCode === -1 &&
        contractCountTransactions.statusCode === 200
      ) {
        this.setState({
          contractPlanExist: false,
          loading: false,
          userType: user.userMetaData.userMifirma.userType.id,
        });
      } else {
        this.setState({
          contractPlanExist: true,
          loading: false,
          userType: user.userMetaData.userMifirma.userType.id,
        });
      }
    } catch (error) {
      if (error && error.response && Number(error.response.status) === 403) {
        this.setState({
          loading: false,
          contractPlanExist: true
        })

        this.toggleErrorRequesting('No tienes los permisos necesarios. Contacta a tu administrador', 4000, false, "/digital-contract/home")
        setTimeout(() => {
          this.props.changeRoute()
        }, 4000)
        return
      }

      this.setState({
        loading: false
      })

      this.toggleErrorRequesting('Ocurrió un error al consultar los cuestionarios', 4000, false, "/digital-contract/home")
      setTimeout(() => {
        this.props.changeRoute()
      }, 4000)
    }
  }

  toggleErrorRequesting = (message, time, sendInbox, path) => {
    let sendTo = (path && path !== '') ? path : "/"
    this.setState({
      showErrorRequesting: true,
      messageError: message
    }, () => {
      setTimeout(() => {
        this.setState({
          showErrorRequesting: false,
        })
        if (sendInbox) {
          const locationState = this.props.location.state
          if (locationState && locationState.from) {
            this.props.history.push({
              pathname: locationState.from,
              state: locationState
            })
          } else {
            this.props.history.push(sendTo)
          }
        }
      }, time || 4000)
    })
  }

  render() {
    return (
      <ContractRequestPanelView
        {...this.state}
        toggleErrorRequesting={this.toggleErrorRequesting}
        {...this.props}
      />
    );
  }
}

export default withTranslation()(ContractRequestPanelAction);